import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

// Suppress the benign "ResizeObserver loop" warning that CRA's dev-only error
// overlay escalates into a full-screen ERROR. It does not affect app behavior
// or the production build. See: https://github.com/WICG/resize-observer/issues/38
const RESIZE_OBSERVER_ERRORS = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
];

window.addEventListener('error', (e) => {
  if (RESIZE_OBSERVER_ERRORS.includes(e.message)) {
    e.stopImmediatePropagation();
    // Hide the dev-server overlay if it already rendered this frame.
    const overlay = document.getElementById('webpack-dev-server-client-overlay');
    if (overlay) overlay.style.display = 'none';
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);